import React, { useState, useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";

import Swal from "sweetalert2";
import { useAppSelector } from "../../../hooks/hooks";

import { useNavigate, useParams } from "react-router-dom";
import landing_house from "../../../redux/reducers/landingReducer";
import { ModalEditName } from "../../../designs/modalEdit/ModalEditName";
import { ModalEditPrecioBase } from "../../../designs/modalEdit/ModalEditPrecioBase";
import { ModalEditCapacidades } from "../../../designs/modalEdit/ModalEditCapacidades";
import { ModalEditImageCarrousel } from "../../../designs/modalEdit/ModalEditImageCarrousel";
import { ModalEditDescripcion1 } from "../../../designs/modalEdit/ModalEditDescripcion1";
import { ModalEditDescripcion2 } from "../../../designs/modalEdit/ModalEditDescripcion2";
import { ModalEditRooms } from "../../../designs/modalEdit/ModalEditRooms";
import { ModalEditComforts } from "../../../designs/modalEdit/ModalEditComforts";
import { ModalEditEvents } from "../../../designs/modalEdit/ModalEditEvents";
import { ModalEditLocation } from "../../../designs/modalEdit/ModalEditLocation";
import { useDispatchDominio } from "../../../hooks/useDispatchDominio";
import { NavbarBroker } from "../../dashboardBroker/NavbarBroker";
import { NavbarMobileBroker } from "../../dashboardBroker/NavbarMobileBroker";
import { NavbarHotel } from "../NavbarHotel";
import { NavbarMobileHotel } from "../NavbarMobileHotel";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import Spinner from "../../../components/helpers/Spinner";
import { ModalEditNameHabitacion } from "../../../designs/modalEdit/ModalEditNameHabitacion";
import { ModalEditPrecioBaseHabitacion } from "../../../designs/modalEdit/ModalEditPrecioBaseHabitacion";
import { ModalEditCapacidadesHotel } from "../../../designs/modalEdit/ModalEditCapacidadesHotel";
import { ModalEditImageHabitacion } from "../../../designs/modalEdit/ModalEditImageHabitacion";
import { ModalEditImageTour } from "../../../designs/modalEdit/ModalEditImageTour";
import { ModalEditNameTour } from "../../../designs/modalEdit/ModalEditNameTour";
import { ModalEditHorarioTour } from "../../../designs/modalEdit/ModalEditHorarioTour";
import { ModalEditPrecioPersonasTour } from "../../../designs/modalEdit/ModalEditPrecioPersonasTour";

interface INITAL_STATE_TYPE {
    [key: string]: string;
}

export interface Casa {
    id: number;
    id_hotel: number;
    nombre: string;
    banner: string;
    precio_base: string;
    descripcion: string;
    personas: string;
    banos: string;
    camas: string;
    mascotas: string;
    check_in: string;
    check_out: string;
    orden: number;
    publicado: string;
    terminado: string;
    pagina: string;
    landing: number;
}

export const ConfiguracionesTourHotel = () => {
    const navigate = useNavigate();
    const { plan, tema } = useAppSelector((state) => state.landing_house.house);
    const { tipo_usuario } = useAppSelector((state) => state.usuario_logeado);
    const [casas, setCasas] = useState<Casa | null>(null);

    const { idCasa } = useParams();

    const [modalVisible, setModalVisible] = useState(false);
    const [modalName, setMondalName] = useState("");

    const opcionesPremiumLanding = (titulo: string) => {
        const nombres = ["descripcion 2", "novedades"];

        if (titulo === "descripcion 2" && tema !== "2") {
            return true;
        } else if (titulo === "novedades" && plan < 2) {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        !modalVisible && getCasa();
    }, [idCasa, modalVisible]);

    const getCasa = async () => {
        if (idCasa) {
            const data = await fetchAxiosToken({
                url: `/hoteles_tours/detalle/${idCasa}`,
            });
            console.log(data, "data");
            setCasas(data);
        }
    };

    const OPCIONESLANDING = [
        {
            nombre: "Precio base",
            url: "precio",
            icono: (
                <svg
                    id="Capa_2"
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                    data-name="Capa 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 99.97 100">
                    <g id="Testimonios">
                        <g>
                            <path
                                fill="#333333"
                                d="m0,16.11c.56-2.36,1.59-4.45,3.41-6.12,2.09-1.92,4.58-2.86,7.37-2.87,14.11-.03,28.22-.02,42.33,0,2.32,0,3.99,1.51,4.08,3.6.08,1.99-1.39,3.5-3.68,3.77-.51.06-1.04.06-1.56.06-13.36,0-26.73,0-40.09,0-.52,0-1.04,0-1.56.04-1.56.13-2.86,1.41-3.01,2.96-.03.26-.02.52-.02.78,0,23.51,0,47.02,0,70.52,0,.52,0,1.03.18,1.54.48,1.36,1.62,2.26,3.06,2.33.81.04,1.63.02,2.44.02,20.48,0,40.97,0,61.45,0,2.14,0,3.46-.91,3.87-2.69.11-.5.1-1.03.1-1.55,0-11.38,0-22.76,0-34.14,0-.62,0-1.23.2-1.83.56-1.73,2.19-2.74,4.03-2.5,1.65.21,2.99,1.68,3.09,3.4.02.39.01.78.01,1.17,0,11.28-.11,22.57.05,33.85.08,5.88-3.69,10.44-8.62,11.45-.09.02-.18.08-.27.12H8.78c-1.56-.45-3.08-.98-4.42-1.95-2.35-1.71-3.66-4.07-4.36-6.82V16.11Z"
                            />
                            <path
                                fill="#333333"
                                d="m99.97,13.83c-.03,3.61-1.28,6.73-3.73,9.36-.97,1.05-2.01,2.04-3.02,3.05-14.53,14.53-29.06,29.05-43.57,43.58-.87.88-1.85,1.49-3.02,1.88-6.6,2.18-13.2,4.38-19.79,6.58-.78.26-1.56.42-2.39.32-1.93-.24-3.34-2-3.1-3.93.06-.51.2-1.02.37-1.51,2.24-6.72,4.49-13.43,6.73-20.15.32-.95.81-1.75,1.52-2.46,15.43-15.41,30.84-30.84,46.28-46.25,5.88-5.87,14.85-5.72,20.28.34,2.32,2.59,3.48,5.68,3.45,9.18Z"
                            />
                        </g>
                    </g>
                </svg>
            ),
        },
        {
            nombre: "Horarios",
            url: "horario",
            icono: (
                <svg
                    id="Capa_2"
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                    data-name="Capa 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 99.97 100">
                    <g id="Testimonios">
                        <g>
                            <path
                                fill="#333333"
                                d="m0,16.11c.56-2.36,1.59-4.45,3.41-6.12,2.09-1.92,4.58-2.86,7.37-2.87,14.11-.03,28.22-.02,42.33,0,2.32,0,3.99,1.51,4.08,3.6.08,1.99-1.39,3.5-3.68,3.77-.51.06-1.04.06-1.56.06-13.36,0-26.73,0-40.09,0-.52,0-1.04,0-1.56.04-1.56.13-2.86,1.41-3.01,2.96-.03.26-.02.52-.02.78,0,23.51,0,47.02,0,70.52,0,.52,0,1.03.18,1.54.48,1.36,1.62,2.26,3.06,2.33.81.04,1.63.02,2.44.02,20.48,0,40.97,0,61.45,0,2.14,0,3.46-.91,3.87-2.69.11-.5.1-1.03.1-1.55,0-11.38,0-22.76,0-34.14,0-.62,0-1.23.2-1.83.56-1.73,2.19-2.74,4.03-2.5,1.65.21,2.99,1.68,3.09,3.4.02.39.01.78.01,1.17,0,11.28-.11,22.57.05,33.85.08,5.88-3.69,10.44-8.62,11.45-.09.02-.18.08-.27.12H8.78c-1.56-.45-3.08-.98-4.42-1.95-2.35-1.71-3.66-4.07-4.36-6.82V16.11Z"
                            />
                            <path
                                fill="#333333"
                                d="m99.97,13.83c-.03,3.61-1.28,6.73-3.73,9.36-.97,1.05-2.01,2.04-3.02,3.05-14.53,14.53-29.06,29.05-43.57,43.58-.87.88-1.85,1.49-3.02,1.88-6.6,2.18-13.2,4.38-19.79,6.58-.78.26-1.56.42-2.39.32-1.93-.24-3.34-2-3.1-3.93.06-.51.2-1.02.37-1.51,2.24-6.72,4.49-13.43,6.73-20.15.32-.95.81-1.75,1.52-2.46,15.43-15.41,30.84-30.84,46.28-46.25,5.88-5.87,14.85-5.72,20.28.34,2.32,2.59,3.48,5.68,3.45,9.18Z"
                            />
                        </g>
                    </g>
                </svg>
            ),
        },
        {
            nombre: "Nombre",
            url: "nombre",
            icono: (
                <svg
                    id="Capa_2"
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                    data-name="Capa 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 99.97 100">
                    <g id="Testimonios">
                        <g>
                            <path
                                fill="#333333"
                                d="m0,16.11c.56-2.36,1.59-4.45,3.41-6.12,2.09-1.92,4.58-2.86,7.37-2.87,14.11-.03,28.22-.02,42.33,0,2.32,0,3.99,1.51,4.08,3.6.08,1.99-1.39,3.5-3.68,3.77-.51.06-1.04.06-1.56.06-13.36,0-26.73,0-40.09,0-.52,0-1.04,0-1.56.04-1.56.13-2.86,1.41-3.01,2.96-.03.26-.02.52-.02.78,0,23.51,0,47.02,0,70.52,0,.52,0,1.03.18,1.54.48,1.36,1.62,2.26,3.06,2.33.81.04,1.63.02,2.44.02,20.48,0,40.97,0,61.45,0,2.14,0,3.46-.91,3.87-2.69.11-.5.1-1.03.1-1.55,0-11.38,0-22.76,0-34.14,0-.62,0-1.23.2-1.83.56-1.73,2.19-2.74,4.03-2.5,1.65.21,2.99,1.68,3.09,3.4.02.39.01.78.01,1.17,0,11.28-.11,22.57.05,33.85.08,5.88-3.69,10.44-8.62,11.45-.09.02-.18.08-.27.12H8.78c-1.56-.45-3.08-.98-4.42-1.95-2.35-1.71-3.66-4.07-4.36-6.82V16.11Z"
                            />
                            <path
                                fill="#333333"
                                d="m99.97,13.83c-.03,3.61-1.28,6.73-3.73,9.36-.97,1.05-2.01,2.04-3.02,3.05-14.53,14.53-29.06,29.05-43.57,43.58-.87.88-1.85,1.49-3.02,1.88-6.6,2.18-13.2,4.38-19.79,6.58-.78.26-1.56.42-2.39.32-1.93-.24-3.34-2-3.1-3.93.06-.51.2-1.02.37-1.51,2.24-6.72,4.49-13.43,6.73-20.15.32-.95.81-1.75,1.52-2.46,15.43-15.41,30.84-30.84,46.28-46.25,5.88-5.87,14.85-5.72,20.28.34,2.32,2.59,3.48,5.68,3.45,9.18Z"
                            />
                        </g>
                    </g>
                </svg>
            ),
        },
        {
            nombre: "Fotos",
            url: "foto",
            icono: (
                <svg
                    id="Capa_2"
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                    data-name="Capa 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 99.97 100">
                    <g id="Testimonios">
                        <g>
                            <path
                                fill="#333333"
                                d="m0,16.11c.56-2.36,1.59-4.45,3.41-6.12,2.09-1.92,4.58-2.86,7.37-2.87,14.11-.03,28.22-.02,42.33,0,2.32,0,3.99,1.51,4.08,3.6.08,1.99-1.39,3.5-3.68,3.77-.51.06-1.04.06-1.56.06-13.36,0-26.73,0-40.09,0-.52,0-1.04,0-1.56.04-1.56.13-2.86,1.41-3.01,2.96-.03.26-.02.52-.02.78,0,23.51,0,47.02,0,70.52,0,.52,0,1.03.18,1.54.48,1.36,1.62,2.26,3.06,2.33.81.04,1.63.02,2.44.02,20.48,0,40.97,0,61.45,0,2.14,0,3.46-.91,3.87-2.69.11-.5.1-1.03.1-1.55,0-11.38,0-22.76,0-34.14,0-.62,0-1.23.2-1.83.56-1.73,2.19-2.74,4.03-2.5,1.65.21,2.99,1.68,3.09,3.4.02.39.01.78.01,1.17,0,11.28-.11,22.57.05,33.85.08,5.88-3.69,10.44-8.62,11.45-.09.02-.18.08-.27.12H8.78c-1.56-.45-3.08-.98-4.42-1.95-2.35-1.71-3.66-4.07-4.36-6.82V16.11Z"
                            />
                            <path
                                fill="#333333"
                                d="m99.97,13.83c-.03,3.61-1.28,6.73-3.73,9.36-.97,1.05-2.01,2.04-3.02,3.05-14.53,14.53-29.06,29.05-43.57,43.58-.87.88-1.85,1.49-3.02,1.88-6.6,2.18-13.2,4.38-19.79,6.58-.78.26-1.56.42-2.39.32-1.93-.24-3.34-2-3.1-3.93.06-.51.2-1.02.37-1.51,2.24-6.72,4.49-13.43,6.73-20.15.32-.95.81-1.75,1.52-2.46,15.43-15.41,30.84-30.84,46.28-46.25,5.88-5.87,14.85-5.72,20.28.34,2.32,2.59,3.48,5.68,3.45,9.18Z"
                            />
                        </g>
                    </g>
                </svg>
            ),
        },
    ];
    const render = () => {
        return (
            <div className="w-full">
                <div className="w-full ">
                    {modalName === "nombre" && modalVisible && casas && (
                        <ModalEditNameTour
                            modalVisible
                            setModalVisible={setModalVisible}
                            descripcion={casas?.descripcion}
                            id_tour={casas?.id}
                            nombre={casas?.nombre}
                        />
                    )}
                    {modalName === "precio" && modalVisible && casas && (
                        <ModalEditPrecioPersonasTour
                            modalVisible
                            setModalVisible={setModalVisible}
                            id_tour={casas?.id}
                            precio_base={casas?.precio_base}
                            personas={casas?.personas}
                        />
                    )}
                    {modalName === "horario" && modalVisible && casas && (
                        <ModalEditHorarioTour
                            modalVisible
                            setModalVisible={setModalVisible}
                            id_tour={casas?.id}
                        />
                    )}
                    {modalName === "foto" && modalVisible && casas && (
                        <ModalEditImageTour
                            modalVisible
                            setModalVisible={setModalVisible}
                            banner={casas?.banner}
                            id_tour={casas?.id}
                        />
                    )}

                    <div className="max-w-4xl gap-8 px-2 pt-4 mx-auto mt-10 xs:grid-cols-3 lg:grid-cols-4">
                        <p className="text-[#029BFC] text-lg font-bold">
                            Editar Tour
                        </p>
                    </div>
                    <div className="grid w-11/12 max-w-4xl grid-cols-2 gap-8 px-2 mx-auto mt-12 mb-10 text-sm xs:grid-cols-3 lg:grid-cols-4 2xl:text-base">
                        {OPCIONESLANDING.map((opcion, index) => {
                            return (
                                <div
                                    onClick={() => (
                                        !opcionesPremiumLanding(opcion.url) &&
                                            setMondalName(opcion.url),
                                        setModalVisible(true)
                                    )}
                                    className={`cursor-pointer border  pb-12 pt-4 px-6 rounded-lg shadow-md relative `}
                                    key={index}>
                                    <p>{opcion.nombre}</p>

                                    <div className="absolute bottom-4 right-4">
                                        <p className="">{opcion.icono}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };
    return (
        <>
            <NavbarHotel titulo={`Configuraciones de ${casas?.nombre}`}>
                {idCasa && casas ? (
                    render()
                ) : (
                    <div className="flex-col items-center justify-center">
                        <div className="flex items-center justify-center mx-auto w-28 h-28">
                            <Spinner width={28} />
                        </div>
                        <div className="mt-5 text-xl text-center">
                            Por favor, aguarde mientras cargamos los datos.
                        </div>
                    </div>
                )}
                <NavbarMobileHotel />
            </NavbarHotel>
        </>
    );
};
